import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Road Information questions
export const roadInformationMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-park-lane-1',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-park-lane-1o1', text: { en: 'National speed limits', nl: 'Nationale snelheidslimieten', ar: 'حدود السرعة الوطنية' } },
      { id: 'q-park-lane-1o2', text: { en: 'Expressway', nl: 'Autoweg', ar: 'طريق سريع' } },
      { id: 'q-park-lane-1o3', text: { en: 'Highway', nl: 'Snelweg', ar: 'طريق سريع' } }
    ],
    correctAnswerId: 'q-park-lane-1o1',
    explanation: {
      en: 'This sign indicates the national speed limits that apply on different types of roads.',
      nl: 'Dit bord geeft de nationale snelheidslimieten aan die gelden op verschillende soorten wegen.',
      ar: 'تشير هذه العلامة إلى حدود السرعة الوطنية التي تنطبق على أنواع مختلفة من الطرق.'
    },
    subject: 'Road Information',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-1.jpg',
    imageHint: 'national speed limits'
  },
  {
    id: 'q-park-lane-2',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-park-lane-2o1', text: { en: 'Parking', nl: 'Parkeren', ar: 'وقوف' } },
      { id: 'q-park-lane-2o2', text: { en: 'Parking area', nl: 'Parkeergebied', ar: 'منطقة وقوف' } },
      { id: 'q-park-lane-2o3', text: { en: 'Parking permitted', nl: 'Parkeren toegestaan', ar: 'الوقوف مسموح' } }
    ],
    correctAnswerId: 'q-park-lane-2o3',
    explanation: {
      en: 'This blue square sign with white "P" indicates that parking is permitted in this area.',
      nl: 'Dit blauwe vierkante bord met witte "P" geeft aan dat parkeren is toegestaan in dit gebied.',
      ar: 'تشير هذه العلامة المربعة الزرقاء مع "P" بيضاء إلى أن الوقوف مسموح في هذه المنطقة.'
    },
    subject: 'Road Information',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-2.jpg',
    imageHint: 'parking permitted'
  },
  {
    id: 'q-park-lane-3',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-park-lane-3o1', text: { en: 'Playground', nl: 'Speelplaats', ar: 'ملعب' } },
      { id: 'q-park-lane-3o2', text: { en: 'End of the residential area', nl: 'Einde van de woonwijk', ar: 'نهاية المنطقة السكنية' } },
      { id: 'q-park-lane-3o3', text: { en: 'Play area', nl: 'Speelgebied', ar: 'منطقة لعب' } }
    ],
    correctAnswerId: 'q-park-lane-3o2',
    explanation: {
      en: 'This sign indicates the end of a residential area, where special speed limits and rules for residential zones no longer apply.',
      nl: 'Dit bord geeft het einde aan van een woonwijk, waar speciale snelheidslimieten en regels voor woonwijken niet meer gelden.',
      ar: 'تشير هذه العلامة إلى نهاية منطقة سكنية، حيث لم تعد حدود السرعة الخاصة وقواعد المناطق السكنية تنطبق.'
    },
    subject: 'Road Information',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-3.jpg',
    imageHint: 'end of residential area'
  },
  {
    id: 'q-park-lane-4',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-park-lane-4o1', text: { en: 'Priority over oncoming traffic', nl: 'Voorrang op tegemoetkomend verkeer', ar: 'الأولوية على المرور القادم' } },
      { id: 'q-park-lane-4o2', text: { en: 'Right of way over oncoming traffic', nl: 'Voorrangsrecht op tegemoetkomend verkeer', ar: 'حق الأولوية على المرور القادم' } },
      { id: 'q-park-lane-4o3', text: { en: 'Priority for oncoming traffic', nl: 'Voorrang voor tegemoetkomend verkeer', ar: 'الأولوية للمرور القادم' } }
    ],
    correctAnswerId: 'q-park-lane-4o1',
    explanation: {
      en: 'This blue square sign with red arrow down and white arrow up indicates that you have priority over oncoming traffic in narrow sections.',
      nl: 'Dit blauwe vierkante bord met rode pijl naar beneden en witte pijl naar boven geeft aan dat je voorrang hebt op tegemoetkomend verkeer in smalle secties.',
      ar: 'تشير هذه العلامة المربعة الزرقاء مع سهم أحمر لأسفل وسهم أبيض لأعلى إلى أن لديك الأولوية على المرور القادم في الأقسام الضيقة.'
    },
    subject: 'Road Information',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-4.jpg',
    imageHint: 'priority oncoming traffic'
  },
  {
    id: 'q-park-lane-5',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-park-lane-5o1', text: { en: 'Priority road', nl: 'Voorrangsweg', ar: 'طريق ذو أولوية' } },
      { id: 'q-park-lane-5o2', text: { en: 'Priority road ends', nl: 'Voorrangsweg eindigt', ar: 'ينتهي طريق الأولوية' } },
      { id: 'q-park-lane-5o3', text: { en: 'Priority route', nl: 'Voorrangsroute', ar: 'مسار ذو أولوية' } }
    ],
    correctAnswerId: 'q-park-lane-5o2',
    explanation: {
      en: 'This sign indicates the end of a priority road. After this sign, you no longer have priority over other traffic.',
      nl: 'Dit bord geeft het einde aan van een voorrangsweg. Na dit bord heb je niet meer voorrang op ander verkeer.',
      ar: 'تشير هذه العلامة إلى نهاية طريق ذي أولوية. بعد هذه العلامة، لم تعد لديك الأولوية على المرور الآخر.'
    },
    subject: 'Road Information',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-5.jpg',
    imageHint: 'priority road ends'
  },
  {
    id: 'q-park-lane-6',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-park-lane-6o1', text: { en: 'Destination', nl: 'Bestemming', ar: 'الوجهة' } },
      { id: 'q-park-lane-6o2', text: { en: 'Begin of a built-up area', nl: 'Begin van een bebouwde kom', ar: 'بداية منطقة مبنية' } },
      { id: 'q-park-lane-6o3', text: { en: 'Direction sign', nl: 'Richtingsbord', ar: 'علامة اتجاه' } }
    ],
    correctAnswerId: 'q-park-lane-6o2',
    explanation: {
      en: 'This sign indicates the beginning of a built-up area, where specific speed limits and traffic rules for urban areas apply.',
      nl: 'Dit bord geeft het begin aan van een bebouwde kom, waar specifieke snelheidslimieten en verkeersregels voor stedelijke gebieden gelden.',
      ar: 'تشير هذه العلامة إلى بداية منطقة مبنية، حيث تنطبق حدود السرعة المحددة وقواعد المرور للمناطق الحضرية.'
    },
    subject: 'Road Information',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-6.jpg',
    imageHint: 'begin of built-up area'
  },
  {
    id: 'q-park-lane-7',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-park-lane-7o1', text: { en: 'Lanes merging from the left', nl: 'Rijstroken die van links samenkomen', ar: 'ممرات تندمج من اليسار' } },
      { id: 'q-park-lane-7o2', text: { en: 'End of a lane', nl: 'Einde van een rijstrook', ar: 'نهاية ممر' } },
      { id: 'q-park-lane-7o3', text: { en: 'Merge lanes', nl: 'Rijstroken samenvoegen', ar: 'دمج الممرات' } }
    ],
    correctAnswerId: 'q-park-lane-7o2',
    explanation: {
      en: 'This sign indicates the end of a lane. Drivers should merge into the remaining lanes before the lane ends.',
      nl: 'Dit bord geeft het einde aan van een rijstrook. Bestuurders moeten samenvoegen in de resterende rijstroken voordat de rijstrook eindigt.',
      ar: 'تشير هذه العلامة إلى نهاية ممر. يجب على السائقين الاندماج في الممرات المتبقية قبل انتهاء الممر.'
    },
    subject: 'Road Information',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-7.jpg',
    imageHint: 'end of lane'
  },
  {
    id: 'q-park-lane-8',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-park-lane-8o1', text: { en: 'Compulsory direction', nl: 'Verplichte richting', ar: 'اتجاه إلزامي' } },
      { id: 'q-park-lane-8o2', text: { en: 'One-way traffic', nl: 'Eenrichtingsverkeer', ar: 'مرور باتجاه واحد' } },
      { id: 'q-park-lane-8o3', text: { en: 'Direction arrow', nl: 'Richtingspijl', ar: 'سهم اتجاه' } }
    ],
    correctAnswerId: 'q-park-lane-8o2',
    explanation: {
      en: 'This sign indicates one-way traffic. Traffic is only allowed to travel in the direction shown by the arrow.',
      nl: 'Dit bord geeft eenrichtingsverkeer aan. Verkeer mag alleen in de richting reizen die door de pijl wordt aangegeven.',
      ar: 'تشير هذه العلامة إلى مرور باتجاه واحد. يسمح للمرور بالسفر فقط في الاتجاه الموضح بالسهم.'
    },
    subject: 'Road Information',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-8.jpg',
    imageHint: 'one-way traffic'
  },
  {
    id: 'q-park-lane-9',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-park-lane-9o1', text: { en: 'Height restriction', nl: 'Hoogtebeperking', ar: 'قيود الارتفاع' } },
      { id: 'q-park-lane-9o2', text: { en: 'Maximum width of a lane', nl: 'Maximale breedte van een rijstrook', ar: 'الحد الأقصى لعرض الممر' } },
      { id: 'q-park-lane-9o3', text: { en: 'Height limit', nl: 'Hoogtelimiet', ar: 'حد الارتفاع' } }
    ],
    correctAnswerId: 'q-park-lane-9o2',
    explanation: {
      en: 'This sign indicates the maximum width of a lane. Vehicles wider than the specified width are not allowed.',
      nl: 'Dit bord geeft de maximale breedte van een rijstrook aan. Voertuigen breder dan de aangegeven breedte zijn niet toegestaan.',
      ar: 'تشير هذه العلامة إلى الحد الأقصى لعرض الممر. المركبات الأوسع من العرض المحدد غير مسموحة.'
    },
    subject: 'Road Information',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-9.jpg',
    imageHint: 'maximum width of lane'
  },
  {
    id: 'q-park-lane-10',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-park-lane-10o1', text: { en: 'End of no entry for motor vehicles', nl: 'Einde van geen toegang voor motorvoertuigen', ar: 'نهاية حظر دخول المركبات الآلية' } },
      { id: 'q-park-lane-10o2', text: { en: 'End of expressway', nl: 'Einde autoweg', ar: 'نهاية الطريق السريع' } },
      { id: 'q-park-lane-10o3', text: { en: 'Motor vehicles allowed', nl: 'Motorvoertuigen toegestaan', ar: 'المركبات الآلية مسموحة' } }
    ],
    correctAnswerId: 'q-park-lane-10o2',
    explanation: {
      en: 'This sign indicates the end of an expressway. After this sign, the special rules and restrictions for expressways no longer apply.',
      nl: 'Dit bord geeft het einde aan van een autoweg. Na dit bord gelden de speciale regels en beperkingen voor autowegen niet meer.',
      ar: 'تشير هذه العلامة إلى نهاية طريق سريع. بعد هذه العلامة، لم تعد القواعد والقيود الخاصة للطرق السريعة تنطبق.'
    },
    subject: 'Road Information',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-10.jpg',
    imageHint: 'end of expressway'
  }
];

























